export var FileUploadStatusState;
(function (FileUploadStatusState) {
    FileUploadStatusState[FileUploadStatusState["FAILED"] = 0] = "FAILED";
    FileUploadStatusState[FileUploadStatusState["PROCESSING"] = 10] = "PROCESSING";
    FileUploadStatusState[FileUploadStatusState["OK"] = 20] = "OK";
})(FileUploadStatusState || (FileUploadStatusState = {}));
//# sourceMappingURL=file-upload-status-state.enum.js.map